// LIBRARIES
import styled from "styled-components";

// MISC

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  // padding: 60px 10px 70px 80px;
`;
export const ButtonContainer = styled.div`
  margin-bottom: 30px;
`;
export const Containers = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
